const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/** Guards a route param before it reaches an API path or query string. */
export const isUuid = (value: string | undefined): value is string => {
  return value !== undefined && UUID_PATTERN.test(value)
}
